import lazyScreen from '../utils/lazyScreen';
const rptARRevenue = lazyScreen(() => import('../pages/rpt/rptARRevenue/index.js'), 'pages/rpt/rptARRevenue/index.js');
const rptARReturnByStore = lazyScreen(() => import('../pages/rpt/rptARReturnByStore/index.js'), 'pages/rpt/rptARReturnByStore/index.js');
const rptARReturnByItem = lazyScreen(() => import('../pages/rpt/rptARReturnByItem/index.js'), 'pages/rpt/rptARReturnByItem/index.js');
const rptEXP = lazyScreen(() => import('../pages/rpt/rptEXP/index.js'), 'pages/rpt/rptEXP/index.js');
const rptCA = lazyScreen(() => import('../pages/rpt/rptCA/index.js'), 'pages/rpt/rptCA/index.js');
const rptICSaleIssueByItem = lazyScreen(() => import('../pages/rpt/rptICSaleIssueByItem/index.js'), 'pages/rpt/rptICSaleIssueByItem/index.js');
const rptICSaleReceiptByItem = lazyScreen(() => import('../pages/rpt/rptICSaleReceiptByItem/index.js'), 'pages/rpt/rptICSaleReceiptByItem/index.js');
const rptARServeMaterialByItem = lazyScreen(() => import('../pages/rpt/rptARServeMaterialByItem/index.js'), 'pages/rpt/rptARServeMaterialByItem/index.js');

export default [
    {
        path: '/rpt/rptARRevenue',
        component: rptARRevenue
    },
    {
        path: '/rpt/rptARReturnByStore',
        component: rptARReturnByStore
    },
    {
        path: '/rpt/rptARReturnByItem',
        component: rptARReturnByItem
    },
    {
        path: '/rpt/rptEXP',
        component: rptEXP
    },
    {
        path: '/rpt/rptCA',
        component: rptCA
    },
    {
        path: '/rpt/rptICSaleIssueByItem',
        component: rptICSaleIssueByItem
    },
    {
        path: '/rpt/rptICSaleReceiptByItem',
        component: rptICSaleReceiptByItem
    },
    {
        path: '/rpt/rptARServeMaterialByItem',
        component: rptARServeMaterialByItem
    }
];
